import NewGetListPaginatedTable from "components/Pagination/GetListPaginatedTable";
import { TableHead, TableHeader, TableRow } from "components/Theme/table";
import CompanyNavLink from "components/navigation/CompanyNavLink";
import DisplayIfUserType from "components/utils/DisplayIfUserType/DisplayIfUserType";
import { OneCardPage } from "components/utils/OneCardPage";
import UserCompanyListItemForm from "containers/profile/UserCompanyListItemForm";
import { companyObjectPageTitle } from "hooks/setPageTitle";
import { useRequiredSelectedCompanyId } from "hooks/useCompany";
import type { User } from "kubb";
import { useGetUserListUserGet } from "kubb";
import type React from "react";
import { convertUserToCompanyUser } from "./users";

const UserList = (): React.ReactElement => {
  const company_id = useRequiredSelectedCompanyId();
  const header = (
    <TableHead>
      <TableRow>
        <TableHeader>Name</TableHeader>
        <TableHeader>Email Address</TableHeader>
        <TableHeader>User Type</TableHeader>
        <TableHeader>Receives Alerts</TableHeader>
        <TableHeader>&nbsp;</TableHeader>
      </TableRow>
    </TableHead>
  );

  const row = (value: User): React.ReactElement => {
    const user = convertUserToCompanyUser(value);
    return (
      <UserCompanyListItemForm
        userCompany={user}
        showUserDetails={true}
        profileAction={false}
      />
    );
  };

  return (
    <OneCardPage
      headerTitle={"Users List"}
      breadcrumbs={[
        { url: "/admin/users", name: "Users" },
        { url: "/admin/users", name: "List" },
      ]}
      showSchemeInBreadcrumbs={false}
      setPageTitle={companyObjectPageTitle("Users")}
    >
      <NewGetListPaginatedTable
        params={{ company_id }}
        cursor={{ max_items: 25 }}
        header={[header, 3]}
        row={row}
        useQuery={useGetUserListUserGet}
        data-cy={"user-list"}
        additionalFunctionButtons={
          <DisplayIfUserType userTypes={["admin"]}>
            <CompanyNavLink
              button={{
                color: "brandLight",
              }}
              to={{ pathname: "/admin/users/create" }}
            >
              Create New User
            </CompanyNavLink>
            <CompanyNavLink
              button={{
                color: "brandLight",
              }}
              to={{ pathname: "/admin/users/api/create" }}
            >
              Create New Api Key
            </CompanyNavLink>
          </DisplayIfUserType>
        }
      />
    </OneCardPage>
  );
};

export default UserList;
